/* eslint-disable no-param-reassign */
import qs from 'qs'
import { useUserStore } from '@/store'
import { platform } from '@/utils/platform'
import { getEnvBaseUrl } from '@/utils'
import i18n from '@/locales'

export type CustomRequestOptions = UniApp.RequestOptions & {
  query?: Record<string, any>
  /** 出错时是否隐藏错误提示 */
  hideErrorToast?: boolean
} & IUniUploadFileOptions // 添加uni.uploadFile参数类型

// 请求基准地址
const baseUrl = getEnvBaseUrl()

// 拦截器配置
const httpInterceptor = {
  // 拦截前触发
  invoke(options: CustomRequestOptions) {
    console.log(options.method, 'options.query=========')
    // 接口请求支持通过 query 参数配置 queryString
    if (options.data) {
      ;(options.data as any).locale = i18n.global.locale.value === 'zh-Hans' ? 'zh_cn' : 'en'
    }
    if (options.query) {
      options.query.locale = i18n.global.locale.value === 'zh-Hans' ? 'zh_cn' : 'en'
      const queryStr = qs.stringify(options.query)
      if (options.url.includes('?')) {
        options.url += `&${queryStr}`
      } else {
        options.url += `?${queryStr}`
      }
    }
    console.log(options, 'options=========')
    // 非 http 开头需拼接地址
    if (!options.url.startsWith('http')) {
      // #ifdef H5
      if (JSON.parse(__VITE_APP_PROXY__)) {
        // 自动拼接代理前缀
        // 根据不同域名使用不同的代理前缀
        if (
          options.url.includes('marketing-center/') ||
          options.url.includes('product-center/') ||
          options.url.includes('expert-plugin/') ||
          options.url.includes('umc/')
        ) {
          options.url = import.meta.env.VITE_SERVER_BASEURL_API + options.url
        } else {
          // 默认前缀
          options.url = import.meta.env.VITE_APP_PROXY_PREFIX + options.url
        }
      } else {
        // options.url = baseUrl + options.url
        // 根据不同域名使用不同的代理前缀
        if (
          options.url.includes('marketing-center/') ||
          options.url.includes('product-center/') ||
          options.url.includes('expert-plugin/') ||
          options.url.includes('umc/')
        ) {
          options.url = import.meta.env.VITE_SERVER_BASEURL_API + options.url
        } else {
          options.url = baseUrl + options.url
        }
      }
      // #endif
      // 非H5正常拼接
      // #ifndef H5
      // options.url = baseUrl + options.url
      // 根据不同域名使用不同的代理前缀
      if (
        options.url.includes('marketing-center/') ||
        options.url.includes('product-center/') ||
        options.url.includes('expert-plugin/') ||
        options.url.includes('umc/')
      ) {
        // 判断是否是开发环境
        if (import.meta.env.MODE === 'development') {
          options.url = import.meta.env.VITE_SERVER_BASEURL__WEIXIN_API + options.url
        } else {
          // 默认前缀
          options.url = import.meta.env.VITE_SERVER_BASEURL_API + options.url
        }
      } else {
        // 默认前缀
        options.url = baseUrl + options.url
      }
      // #endif
      // TIPS: 如果需要对接多个后端服务，也可以在这里处理，拼接成所需要的地址
    }
    // 1. 请求超时
    options.timeout = 20000 // 10s
    // 2. （可选）添加小程序端请求头标识
    options.header = {
      platform, // 可选，与 uniapp 定义的平台一致，告诉后台来源
      ...options.header,
    }
    // 3. 添加 token 请求头标识
    const { token } = useUserStore()
    if (token) {
      options.header.Authorization = `Bearer ${token}`
    }
    options.header.locale = i18n.global.locale.value === 'zh-Hans' ? 'zh_cn' : 'en'
    console.log(options)
  },
}

export const requestInterceptor = {
  install() {
    // 拦截 request 请求
    uni.addInterceptor('request', httpInterceptor)
    // 拦截 uploadFile 文件上传
    uni.addInterceptor('uploadFile', httpInterceptor)
  },
}
